import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, LayoutTemplate, Command } from 'lucide-react';
import { useAdminAuth } from '../../hooks/useAdminAuth';
import { CLASSIC_ADMIN_PREFIX } from '../../config/adminLayers';

interface EnterpriseHeaderProps {
  setSidebarOpen: (open: boolean) => void;
  title?: string;
  onOpenCommandPalette?: () => void;
}

export const EnterpriseHeader: React.FC<EnterpriseHeaderProps> = ({
  setSidebarOpen,
  title,
  onOpenCommandPalette,
}) => {
  const { user } = useAdminAuth();

  return (
    <header className="sticky top-0 z-40 flex h-14 shrink-0 items-center gap-x-4 border-b border-enterprise-700/80 bg-enterprise-900/95 px-4 shadow-lg backdrop-blur sm:px-6 lg:px-8">
      <button
        type="button"
        className="-m-2.5 p-2.5 text-enterprise-200 lg:hidden"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open sidebar"
      >
        <Menu className="h-6 w-6" />
      </button>

      <div className="hidden h-6 w-px bg-enterprise-600 lg:block" aria-hidden />

      <div className="flex min-w-0 flex-1 items-center gap-3">
        {title && (
          <h1 className="truncate text-sm font-semibold text-white sm:text-base">{title}</h1>
        )}
      </div>

      {onOpenCommandPalette && (
        <button
          type="button"
          onClick={onOpenCommandPalette}
          className="hidden items-center gap-2 rounded-md border border-enterprise-600 bg-enterprise-800/50 px-3 py-1.5 text-xs font-medium text-enterprise-100 transition hover:bg-enterprise-800 lg:inline-flex"
        >
          <Command className="h-3.5 w-3.5 shrink-0 opacity-90" />
          <span>Search</span>
          <kbd className="rounded border border-enterprise-500/80 bg-enterprise-950/40 px-1.5 py-0.5 text-[10px] font-normal text-enterprise-300">
            ⌘K
          </kbd>
        </button>
      )}

      <Link
        to={`${CLASSIC_ADMIN_PREFIX}/dashboard`}
        className="hidden items-center gap-2 rounded-md border border-enterprise-600 bg-enterprise-800/50 px-3 py-1.5 text-xs font-medium text-enterprise-100 transition hover:bg-enterprise-800 lg:inline-flex"
      >
        <LayoutTemplate className="h-4 w-4 shrink-0" />
        Classic console
      </Link>

      <div className="flex items-center gap-3 border-l border-enterprise-600 pl-3">
        <div className="hidden text-right sm:block">
          <p className="text-xs font-medium text-white">{user?.name || 'Admin'}</p>
          <p className="truncate text-xs text-enterprise-400">{user?.email || ''}</p>
        </div>
        <div className="h-9 w-9 shrink-0 rounded-full bg-enterprise-accent/20 flex items-center justify-center ring-1 ring-enterprise-accent/40">
          <span className="text-sm font-semibold text-enterprise-accent">{user?.name?.charAt(0) || 'A'}</span>
        </div>
      </div>
    </header>
  );
};
